import { Coding, MeasureReport, MeasureReportGroup, MeasureReportGroupStratifierStratum } from "src/careflow/ph-core/fhir-client/resources";
import { MeasureReportGroups, Stratifier } from "../report/report-type";
import { getRisk, getRiskColorPalette } from "./report";
import { WrappedObservation } from "src/careflow/ph-core/fhir-client/fhir-base/wrappers/Observation";

function isSystemInCoding(list: Coding[] | undefined, matchingSystems: string[] | string | undefined): boolean {
  if (!list || !matchingSystems) return false;

  const systems = Array.isArray(matchingSystems) ? matchingSystems : [matchingSystems];
  
  return list.some(coding => coding.system && systems.includes(coding.system));
}

export function isMedicalComplexityGroup(group: MeasureReportGroup, configurations: any) {
  const matchingSystem = configurations?.systemMedialComplexity;
  return isSystemInCoding(group.code?.coding, matchingSystem);
}

export function isSocialComplexityGroup(group: MeasureReportGroup, configurations: any) {
  const matchingSystem = configurations?.systemSocialComplexity;
  return isSystemInCoding(group.code?.coding, matchingSystem);
}

export function isServiceIntegrationLevelsGroup(group: MeasureReportGroup, configurations: any) {
  const matchingSystem = configurations?.systemServiceIntegrationLevel;
  console.log('configurations?.systemServiceIntegrationLevel',configurations?.systemServiceIntegrationLevel)
  return isSystemInCoding(group.code?.coding, matchingSystem);
}

export function getMeasureReportGroups(measureReport: MeasureReport | undefined, configurations: any) {
  let res: MeasureReportGroups = {
    medicalComplex: undefined,
    socialComplex: undefined,
    serviceIntegration: undefined,
    normal: [],
  };

  measureReport?.group?.forEach((item: MeasureReportGroup) => {
    
    if (isMedicalComplexityGroup(item, configurations)) {
      res.medicalComplex = item;
    } else if (isSocialComplexityGroup(item, configurations)) {
      res.socialComplex = item;
    } else if (isServiceIntegrationLevelsGroup(item, configurations)) {
      res.serviceIntegration = item;
    } else {
      res.normal?.push(item);
    }
    console.log('getMeasureReportGroups',res,item);
  });

  return res;
}

export const getStratumData = (stratum: MeasureReportGroupStratifierStratum) => {
  const riskColorPalette = getRiskColorPalette(
    getRisk(stratum.component?.[0]?.code?.coding?.[0]?.code ?? 'indeterminate-risk')
  );

  const printableStratumData: Stratifier = {
    stratifier_text: stratum.component?.[1]?.value?.text ? stratum.component?.[1]?.value?.text : '',
    risk_text: stratum.component?.[0]?.code?.coding?.[0]?.display || '',
    risk_color: riskColorPalette?.internalBackgroundColor || '#ffffff',
    risk_note:
      (stratum?.component?.[0]?.value?.coding?.[0]?.display !==
        stratum?.component?.[0]?.code?.coding?.[0]?.code &&
        stratum?.component?.[0]?.value?.coding?.[0]?.display) ||
      '',
    score: stratum.measureScore?.value === undefined ? '' : String(stratum.measureScore?.value),
  };

  return printableStratumData;
};

export const getMeasureReportGroupPrintable = (group: MeasureReportGroups) => {
  const { medicalComplex, socialComplex, serviceIntegration } = group;

  return {
    medical_complexity: {
      color: getComplexityScoreRiskColorPalette(medicalComplex)?.internalBackgroundColor,
      value:
        medicalComplex?.stratifier?.[0].stratum?.[0].measureScore?.value === undefined
          ? ''
          : String(medicalComplex?.stratifier?.[0].stratum?.[0].measureScore?.value),
    },
    social_complexity: {
      color: getComplexityScoreRiskColorPalette(socialComplex)?.internalBackgroundColor,
      value:
        socialComplex?.stratifier?.[0].stratum?.[0].measureScore?.value === undefined
          ? ''
          : String(socialComplex?.stratifier?.[0].stratum?.[0].measureScore?.value),
    },
    service_integration_levels: {
      color: getComplexityScoreRiskColorPalette(serviceIntegration)?.internalBackgroundColor,
      value:
        serviceIntegration?.stratifier?.[0].stratum?.[0].measureScore?.value === undefined
          ? ''
          : String(serviceIntegration?.stratifier?.[0].stratum?.[0].measureScore?.value),
    },
  };
};

const getComplexityScoreRiskColorPalette = (group?: MeasureReportGroup) => {
  const riskValue = group?.stratifier?.[0]?.stratum?.[0]?.component?.[0]?.code?.coding?.[0]?.code;

  const riskCodeParsed = riskValue === undefined ? 'none' : getRisk(riskValue);

  return getRiskColorPalette(riskCodeParsed);
};

export const getMeasureReportGroupValue = (group: MeasureReportGroups) => {
  const medicalComplex =
    group?.medicalComplex?.stratifier?.[0].stratum?.[0].measureScore?.value || '';
  const socialComplex =
    group?.socialComplex?.stratifier?.[0].stratum?.[0].measureScore?.value || '';
  const serviceIntegration =
    group?.serviceIntegration?.stratifier?.[0].stratum?.[0].measureScore?.value || '';

  return {
    medicalComplex,
    socialComplex,
    serviceIntegration,
  };
};

const getObsevationBySystem = (group: WrappedObservation, system: string | string[]) => {
  if (!group?.code?.coding?.[0]?.system || !system) return false;

  const systems = Array.isArray(system) ? system : [system];
  return systems.includes(group.code.coding[0].system);
}

export const getObservationtypeValue = (observations: WrappedObservation[] | undefined, configurations: any) => {
  let res: MeasureReportGroups = {
    medicalComplex: undefined,
    socialComplex: undefined,
    serviceIntegration: undefined,
    normal: [],
  };

  observations?.forEach((item: any) => {
    if (getObsevationBySystem(item, configurations?.systemMedialComplexity)) {
      res.medicalComplex = item;
    } else if (getObsevationBySystem(item, configurations?.systemSocialComplexity)) {
      res.socialComplex = item;
    } else if (
      getObsevationBySystem(item, configurations?.systemServiceIntegrationLevel)
    ) {
      res.serviceIntegration = item;
    } else {
      res.normal?.push(item);
    }
  });

  return res;
};